import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import { translateToType, TBS_TRANSLATE } from '../helper/configurator_name_translator';
import {forOwn} from '../../../lib/utilities';

class ConfiguratorStoreClass extends ReduceStore {
    getInitialState() {
        return {
            usage: '',
            width: '',
            profile: '',
            rim: '',
            usageOptions: [],
            usageOptionsLoading: false,
            widthOptions: [],
            widthOptionsLoading: false,
            profileOptions: [],
            profileOptionsLoading: false,
            rimOptions: [],
            rimOptionsLoading: false,
            loadingError: false,
            postcode: '',
            userInteracted: false,
        };
    }

    reduce(state, { source, action }) {
        if (source === 'CONFIGURATOR_ACTION') {
            switch (action.type) {
            case 'UPDATE_USAGE':
                if (state.usage !== action.payload) {
                    state.usage = action.payload;
                    this.__emitChange();
                }
                break;
            case 'UPDATE_WIDTH':
                if (state.width !== action.payload) {
                    state.width = action.payload;
                    this.__emitChange();
                }
                break;
            case 'UPDATE_PROFILE':
                if (state.profile !== action.payload) {
                    state.profile = action.payload;
                    this.__emitChange();
                }
                break;
            case 'UPDATE_RIM':
                if (state.rim !== action.payload) {
                    state.rim = action.payload;
                    this.__emitChange();
                }
                break;

            case 'LOADING_START_TBS':
                state.loading = true;
                state.loadingError = false;
                this.__emitChange();
                break;

            case 'UPDATE_TBS_OPTIONS':
                state.loading = false;

                forOwn(action.payload, (options, type) => {
                    const translatedType = translateToType(type, TBS_TRANSLATE);

                        // set options
                    state[`${translatedType}Options`] = action.payload[type];

                        // check if existing selected value still available
                    if (!state[`${translatedType}Options`].find(item => parseInt(item[0]) === parseInt(state[translatedType]))) {
                        state[translatedType] = '';
                    }
                });

                this.__emitChange();
                break;

            case 'OPTIONS_LOADING_ERROR_TBS':
                state.loading = false;
                state.loadingError = true;
                this.__emitChange();
                break;

            case 'UPDATE_POSTCODE':
                if (state.postcode !== action.payload) {
                    state.postcode = action.payload;
                    this.__emitChange();
                }
                break;

            case 'UPDATE_FIRST_USER_INTERACTION':
                if (state.userInteracted !== true) {
                    state.userInteracted = true;
                    this.__emitChange();
                }
                break;
            }
        }

        return state;
    }
}

const ConfiguratorStore = new ConfiguratorStoreClass(Dispatcher);
export default ConfiguratorStore;
